import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  Box,
  IconButton,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Add } from "@mui/icons-material";
import {
  validateNumber,
  validateNumberInput,
  validatePercentage,
} from "../../../../utils/validateFields";
import DeleteRowDialog from "../../../../Components/Common/DeleteRowDialog";
import DeleteTableDialog from "./DeleteTableDialog";
import { getRowErrorMessages } from "../../../../utils/getRowErrorMessage";
import { fixedPercentage } from "../../../../utils/common";

const BusinessPartnerTable = ({
  inputData,
  tables,
  setTables,
  errors,
  setErrors,
  disabled,
  hide,
  field1,
}) => {
  console.log("BusinessPartnerTable", tables);
  const [isFilled, setIsFilled] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [fieldToRemove, setFieldToRemove] = useState({
    tableIndex: null,
    rowIndex: null,
  });
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [tableToDelete, setTableToDelete] = useState(null);

  const handleAddTable = () => {
    setTables((prev) => [
      ...prev,
      {
        region: "",
        rows: [
          {
            typeOfBusiness: "",
            totalBusinessPartners: "",
            noOfCategory: "",
            antiCorruptionPolicies: "",
            percentage: "",
          },
        ],
      },
    ]);

    console.log(tables, tables?.length, "table1");
  };

  const isFirstTableComplete = () => {
    if (!tables.length || !tables[0].rows.length) return false; // No tables or rows exist

    // Check if any field in the first row of the first table has data
    return tables[0].rows.some((row) =>
      Object.values(row).some((value) => value && value.trim() !== "")
    );
  };

  // Add a new row to a specific table
  const handleAddRow = (tableIndex) => {
    const updatedTables = [...tables];
    updatedTables[tableIndex].rows = updatedTables[tableIndex].rows || []; // Ensure rows exist
    updatedTables[tableIndex].rows.push({
      typeOfBusiness: "",
      totalBusinessPartners: "",
      noOfCategory: "",
      antiCorruptionPolicies: "",
      percentage: "",
    });
    setTables(updatedTables);
  };

  const cancelRemoveRow = () => {
    setOpenDialog(false);
  };

  const confirmRemoveRow = () => {
    if (fieldToRemove) {
      const { tableIndex, rowIndex } = fieldToRemove;
      setTables((prev) => {
        const newTables = [...prev];
        newTables[tableIndex].rows.splice(rowIndex, 1);
        return newTables;
      });
    }
    setOpenDialog(false);
  };

  const handleDeleteRow = (tableIndex, rowIndex) => {
    setTables((prev) => {
      const newTables = [...prev];
      if (
        Object.values(newTables[tableIndex].rows[rowIndex]).some((val) => val)
      ) {
        setOpenDialog(true);
        setFieldToRemove({ tableIndex, rowIndex });
        return newTables;
      }

      newTables[tableIndex].rows.splice(rowIndex, 1);
      return newTables;
    });
  };

  // const handleDeleteTable = (indexToDelete) => {
  //   const updatedTables = tables
  //     .filter((_, index) => index !== indexToDelete) // Remove the selected table
  //     .map((table, index) => ({
  //       ...table,
  //       fieldName: `Region ${index + 1}`, // Recalculate region names
  //     }));
  //   setTables(updatedTables);
  // };

  const handleDeleteTable = (index) => {
    const hasData = tables[index].rows.some(
      (row) =>
        row.typeOfBusiness ||
        row.totalBusinessPartners ||
        row.noOfCategory ||
        row.percentage ||
        row.antiCorruptionPolicies
    );

    if (hasData) {
      setTableToDelete(index);
      setOpenDeleteDialog(true);
    } else {
      deleteTable(index);
    }
  };

  const deleteTable = (indexToDelete) => {
    const updatedTables = tables
      .filter((_, index) => index !== indexToDelete)
      .map((table, index) => ({
        ...table,
        // fieldName: `Region ${index + 1}`,
        region: table.region.startsWith("Region")
          ? `Region ${index + 1}`
          : table.region,
      }));
    setTables(updatedTables);
  };

  const handleInputChange = (tableIndex, rowIndex, fieldName, value, type) => {
    if (type === "percentage" && !validatePercentage(value)) return;
    if (type === "number" && !validateNumberInput(value)) return;
    const updatedTables = [...tables];
    updatedTables[tableIndex].rows[rowIndex][fieldName] = value;

    const totalBusinessPartners = parseFloat(
      updatedTables[tableIndex].rows[rowIndex]["totalBusinessPartners"]
    );
    const noOfCategory = parseFloat(
      updatedTables[tableIndex].rows[rowIndex]["noOfCategory"]
    );

    // Validation: Ensure noOfCategory is not greater than totalBusinessPartners
    if (fieldName === "noOfCategory" || fieldName === "totalBusinessPartners") {
      if (
        !isNaN(noOfCategory) &&
        !isNaN(totalBusinessPartners) &&
        noOfCategory > totalBusinessPartners
      ) {
        addError(
          tableIndex,
          rowIndex,
          "noOfCategory",
          "value should be less than or equal to Total no. of Business partners"
        );
        updatedTables[tableIndex].rows[rowIndex]["percentage"] = ""; // Clear percentage
      } else {
        removeError(tableIndex, rowIndex, "noOfCategory");

        // Calculate percentage only if values are valid
        if (
          !isNaN(noOfCategory) &&
          !isNaN(totalBusinessPartners) &&
          totalBusinessPartners > 0
        ) {
          const percentage = (noOfCategory / totalBusinessPartners) * 100;
          updatedTables[tableIndex].rows[rowIndex]["percentage"] =
            fixedPercentage(percentage);
        } else {
          updatedTables[tableIndex].rows[rowIndex]["percentage"] = "";
        }
      }
    }

    setTables(updatedTables);
    checkIfAdded();
  };

  const addError = (tableIndex, rowIndex, fieldName, errorMessage) => {
    const updatedErrors = { ...errors };
    if (!updatedErrors[tableIndex]) {
      updatedErrors[tableIndex] = {};
    }
    if (!updatedErrors[tableIndex][rowIndex]) {
      updatedErrors[tableIndex][rowIndex] = {};
    }
    updatedErrors[tableIndex][rowIndex][fieldName] = errorMessage;

    setErrors(updatedErrors);
  };

  // Function to remove the error from the error state
  const removeError = (tableIndex, rowIndex, fieldName) => {
    const updatedErrors = { ...errors };

    if (
      updatedErrors[tableIndex] &&
      updatedErrors[tableIndex][rowIndex] &&
      updatedErrors[tableIndex][rowIndex][fieldName]
    ) {
      delete updatedErrors[tableIndex][rowIndex][fieldName];

      if (Object.keys(updatedErrors[tableIndex][rowIndex]).length === 0) {
        delete updatedErrors[tableIndex][rowIndex];
      }

      if (Object.keys(updatedErrors[tableIndex]).length === 0) {
        delete updatedErrors[tableIndex];
      }

      setErrors(updatedErrors);
    }
  };

  useEffect(() => {
    checkIfAdded();
  }, [tables, inputData]); // Run only when tables or inputData change

  const checkIfAdded = () => {
    tables.forEach((table, tableIndex) => {
      const rows = table?.rows || [];
      const lastRow = rows.length > 0 ? rows[rows.length - 1] : {}; // Ensure lastRow is an object
      const filteredLastRow = Object.fromEntries(
        Object.entries(lastRow).filter(([key]) => key !== "_id")
      );

      const optionalLength = inputData?.[tableIndex]?.fields?.filter(
        (el) => el?.optional
      )?.length;
      console.log(optionalLength, "option");
      // Check if lastRow is fully filled
      const isComplete =
        Object.keys(filteredLastRow).length >=
          (inputData?.[tableIndex]?.fields?.length - optionalLength || 0) &&
        Object.values(filteredLastRow)?.every(
          (val) =>
            val !== undefined && val !== "" && val !== null && val?.length !== 0
        );
      console.log("complte", lastRow, isComplete);
      setIsFilled((prevState) => ({
        ...prevState,
        [tableIndex]: !isComplete, // true if incomplete, false if fully filled
      }));
    });
  };

  return (
    <Box>
      <DeleteRowDialog {...{ openDialog, cancelRemoveRow, confirmRemoveRow }} />
      <DeleteTableDialog
        openDialog={openDeleteDialog}
        cancelDelete={() => setOpenDeleteDialog(false)}
        confirmDelete={() => {
          deleteTable(tableToDelete);
          setOpenDeleteDialog(false);
        }}
      />
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "16px",
          mt: 2,
          textIndent: "-1rem",
          paddingLeft: "1rem",
        }}
        gutterBottom
      >
        {inputData[0].title}
      </Typography>

      {/* Loop through tables */}
      {tables.map((table, tableIndex) => (
        <Box key={tableIndex} sx={{ mb: 4, marginLeft: "1rem", width: "98%" }}>
          {/* Region Field with Delete Icon */}
          <TableCell sx={{ padding: "3px" }}>{`Region ${
            tableIndex + 1
          }`}</TableCell>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2,
              width: "100%",
            }}
          >
            {/* Text Field */}
            <TextField
              placeholder={`Enter Region`}
              fullWidth
              sx={{
                width: "30%",
                height: "40px",
                "& .MuiInputBase-root": {
                  height: "40px",
                },
                "& .MuiInputBase-input": {
                  padding: "8px",
                  fontSize: "14px",
                },
              }}
              value={table.region} // Bind value to the region field
              onChange={(e) => {
                const updatedTables = [...tables];
                updatedTables[tableIndex].region = e.target.value; // Update the region field
                setTables(updatedTables);
              }}
              disabled={disabled}
            />
            {tables.length > 1 && (
              <IconButton
                color="error"
                onClick={() => handleDeleteTable(tableIndex)}
                sx={{ width: "5%" }}
                disabled={disabled}
              >
                <DeleteIcon />
              </IconButton>
            )}
          </Box>

          {/* Table */}
          <TableContainer
            component={Paper}
            sx={{
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              borderRadius: "10px",
            }}
          >
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#1C486B" }}>
                  <TableCell
                    sx={{
                      color: "white",
                      fontWeight: 600,
                      borderRight: "1px solid #D3D3D3",
                    }}
                  >
                    S. No.
                  </TableCell>
                  {inputData[0].fields.map((field, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        color: "white",
                        fontWeight: 600,
                        borderRight: "1px solid #D3D3D3",
                        width: field.width,
                      }}
                    >
                      {field.title}
                    </TableCell>
                  ))}
                  <TableCell
                    sx={{
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {table.rows?.map((row, rowIndex) => (
                  <TableRow key={rowIndex}>
                    <TableCell
                      sx={{
                        borderRight: "1px solid #D3D3D3",
                        textAlign: "center",
                        width: "8%",
                      }}
                    >
                      {rowIndex + 1}.
                    </TableCell>
                    {inputData[0].fields.map((field, fieldIndex) => (
                      <TableCell
                        key={fieldIndex}
                        sx={{
                          borderRight: "1px solid #D3D3D3",
                          backgroundColor:
                            field.fieldName === "percentage" ? "#EFEFEF" : "",
                        }}
                      >
                        {field.type === "select" ? (
                          <TextField
                            select
                            value={row[field.fieldName] || ""}
                            onChange={(e) =>
                              handleInputChange(
                                tableIndex,
                                rowIndex,
                                field.fieldName,
                                e.target.value,
                                field.type
                              )
                            }
                            sx={{
                              width: "185px",
                              "& .MuiOutlinedInput-root": {
                                borderRadius: 0,
                                "& fieldset": {
                                  border: "none",
                                },
                              },
                              "& .MuiSelect-select": {
                                padding: "8px",
                              },
                            }}
                            SelectProps={{
                              native: true,
                            }}
                            disabled={disabled}
                          >
                            <option value="" disabled>
                              {field.placeholder}
                            </option>
                            {field.options.map((option, index) => (
                              <option key={index} value={option}>
                                {option}
                              </option>
                            ))}
                          </TextField>
                        ) : (
                          <TextField
                            value={row[field.fieldName] || ""}
                            onChange={(e) =>
                              handleInputChange(
                                tableIndex,
                                rowIndex,
                                field.fieldName,
                                e.target.value,
                                field.type
                              )
                            }
                            size="small"
                            variant="standard"
                            InputProps={{ disableUnderline: true }}
                            placeholder={field.placeholder}
                            fullWidth
                            disabled={field1 === field?.fieldName || disabled}
                          />
                        )}
                      </TableCell>
                    ))}

                    <TableCell>
                      <IconButton
                        color="error"
                        onClick={() => handleDeleteRow(tableIndex, rowIndex)}
                        disabled={table.rows.length === 1} // Disable the button if there's only one row
                        sx={{
                          opacity: table.rows.length === 1 ? 0.5 : 1, // Visual feedback for disabled state
                          cursor:
                            table.rows.length === 1 ? "not-allowed" : "pointer",
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ mt: 1, ml: 0 }}>
            {Object.keys(errors).length > 0 &&
              getRowErrorMessages(tableIndex, inputData, tables, errors).map(
                (errorMessage, idx) => (
                  <p
                    key={idx}
                    color="error"
                    variant="caption"
                    style={{
                      lineHeight: "1.2",
                      margin: "2px 0",
                      color: "#d34040",
                      fontSize: "10px",
                      fontStyle: "italic",
                    }}
                  >
                    {errorMessage}
                  </p>
                )
              )}
          </Box>
          {/* Add New Business Partner Button */}
          {!hide && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                mt: 2,
              }}
            >
              <Button
                disabled={isFilled?.[tableIndex]}
                endIcon={<Add />}
                onClick={() => handleAddRow(tableIndex)}
                sx={{
                  color: "#1C486B",
                  width: "18rem",
                  borderColor: "#1C486B",
                }}
                variant="outlined"
              >
                Add New Business Partner
              </Button>

              {/* Add New Region Button */}
              {tables?.length > 1 && tableIndex < tables?.length - 1 ? (
                <></>
              ) : (
                <Button
                  endIcon={<Add />}
                  onClick={handleAddTable}
                  disabled={isFilled?.[tableIndex] || disabled}
                  sx={{
                    color: "#1C486B",
                    width: "14rem",
                    borderColor: "#1C486B",
                  }}
                  variant="outlined"
                >
                  Add New Region
                </Button>
              )}
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default BusinessPartnerTable;
